import { InfoCircleOutlined, UserOutlined } from '@ant-design/icons';
import { Switch } from 'antd';
import OrderCODItemPrice from 'components/pages/dashboard/ParcelOrder/components/orderMethods/components/OrderCODItemPrice';
import OrderMethodItem from 'components/pages/dashboard/ParcelOrder/components/orderMethods/OrderMethodItem';
import { orderMethodsState } from 'components/pages/dashboard/ParcelOrder/ParcelOrder';
import { packageCreate } from 'global/Models/omOrderModel';
import { FC, useMemo } from 'react';
import { FaHandHoldingUsd } from 'react-icons/fa';

interface IOrderMethodCOD {
  handleChange: (_values: Partial<orderMethodsState>) => void;
  packages: packageCreate[];
  orderMethods: orderMethodsState;
  setPackages: React.Dispatch<React.SetStateAction<packageCreate[]>>;
  haveCOD?: boolean;
}

const OrderMethodCOD: FC<IOrderMethodCOD> = ({ orderMethods, handleChange, packages, setPackages, haveCOD }) => {
  const REVERSED_Logistic_SERVICE_ID = 14;
  const isReversedLogistic = useMemo(() => orderMethods?.serviceId === REVERSED_Logistic_SERVICE_ID, [orderMethods?.serviceId]);

  //functions
  const codChange = (value: boolean) => {
    if (value) return handleChange({ haveCOD: true });
    else handleChange({ haveCOD: false });
    setPackages(packages);
  };

  if (isReversedLogistic) return null;

  return (
    <OrderMethodItem icon={<FaHandHoldingUsd className='mb-2 text-2xl' />} title='دریافت مبلغ کالا'>
      <div className='flex gap-2 '>
        <Switch onChange={codChange} id='is-order-cod-switch' checked={haveCOD} />
        <div>
          <label htmlFor='is-order-cod-switch'>دریافت مبلغ کالا از مشتری</label>
          <span className='block text-xs inherit-color text-t-secondary-text-color'>
            <InfoCircleOutlined className='relative top-[2px]' /> در این حالت، حین تحویل مرسوله، مبلغ بسته از مشتری دریافت می شود.
          </span>
          <span className='block text-xs inherit-color text-t-secondary-text-color'>
            <InfoCircleOutlined className='relative top-[2px]' /> سفارش‌هایی که زمان تسویه آن‌ها در چهار روز پایانی ماه باشد، ابتدای ماه بعد پرداخت خواهند شد
          </span>
        </div>
      </div>
      <div
        className={`py-2 mt-2 bg-t-layer-bg-color grid grid-cols-1 md:grid-cols-2  gap-3 transition-all duration-500 ease-in overflow-y-auto ${
          haveCOD ? 'max-h-[400px] shadow-inner' : 'max-h-[0] bg-transparent'
        }`}>
        {haveCOD && (
          <>
            {packages.map((item, packageIndex) => {
              return (
                <div key={packageIndex} className='p-2 space-y-1 border-r-4 rounded-l-lg border-t-primary-color'>
                  <div className='flex items-center gap-2'>
                    <span className='text-xs color-inherit text-t-secondary-text-color'>
                      <UserOutlined className='ml-1' />
                      گیرنده :
                    </span>

                    <span className='text-sm'>
                      {item.receiverAddress?.address.cityTitle} - {item.receiverClient?.fullName}
                    </span>
                  </div>
                  <div className='w-full space-y-2'>
                    {item.package?.map((packaging, packagingIndex) => {
                      return <OrderCODItemPrice setPackages={setPackages} packageIndex={packageIndex} packagingIndex={packagingIndex} packaging={packaging} key={packagingIndex} />;
                    })}
                  </div>
                </div>
              );
            })}
          </>
        )}
      </div>
    </OrderMethodItem>
  );
};

export default OrderMethodCOD;
